import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface UpdateStudentTuitionFeeParams {
  studentId: string;
  subscriptionId?: string;
  enrollmentId: string;
  amount: number;
  baseAmount?: number;
  finalAmount?: number;
  discountValue?: number;
  discountAmount?: number;
}

export const updateStudentTuitionFee = async ({
  studentId,
  ...params
}: UpdateStudentTuitionFeeParams) => {
  const response = await baseAPI.put<unknown>(
    `/students/${studentId}/tuition-fee`,
    params,
  );
  return response.data;
};

export const useUpdateStudentTuitionFeeMutation = () => {
  return useMutation({
    mutationFn: (params: UpdateStudentTuitionFeeParams) =>
      updateStudentTuitionFee(params),
    onSuccess: (_, y) => {
      const studentId = y.studentId;
      void queryClient.invalidateQueries({
        queryKey: [KEYS.TUITION_DETAILS, studentId],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.UPCOMING_SUBSCRIPTION_INVOICES, studentId],
      });
    },
  });
};
